import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "./../../features/projects/projectSlice";
import { Container, Col, Row, Button, Dropdown, Form } from "react-bootstrap";
import { NGDropdownListItem, SXDropdown } from "@common/components/ui-components/SXDropdown";
import { SXModalBase } from "./SXModal";
import { useTranslation } from "react-i18next";
import { selectUser, updateUserSettings, UserSlice, useUser } from "../../features/user/userSlice";
import { AlertMessage, ErrorType } from "../../helpers/AlertMessage";
import { openModal, closeModal } from "../../features/ui/uiSlice";
import "../../../i18n";
import { languages } from "../../config/languages";
import { useDevConfig } from "../../App";

interface SettingsModalProps {
  isSettingsModalOpen: boolean;
  analyse: (project: any) => Promise<void>;
}

export const SettingsModal = (props: SettingsModalProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { deleteUser, updateSettingsForUser, getUser } = useUser();
  const isDev = useDevConfig();
  const [showUserDelete, setShowUserDelete] = useState(false);
  const selProject = useSelector(selectProject);
  let user = useSelector(selectUser);
  const handleLanguageSelect = async (langCode: string) => {
    await i18n.changeLanguage(langCode);

    const updatedUser = {
      ...user,
      settings: { ...user.settings, lang: langCode },
    };

    await dispatch(UserSlice.actions.setUser(updatedUser)); // update Redux store

    await updateSettingsForUser(updatedUser);
  };
  const resetDefault = async () => {
    await i18n.changeLanguage("en");
    const updatedUser = {
      ...user,
      settings: { lang: "en", showDisclaimer: true, autoZoomViewportEnabled: false, analyseOnSave: false },
    };

    await dispatch(UserSlice.actions.setUser(updatedUser)); // update Redux store

    await updateSettingsForUser(updatedUser);
  };

  const handleAnalyseOnSaveChange = async (analyseOnSave: boolean) => {
    console.log({ ...user.settings, analyseOnSave });
    const updatedUser = {
      ...user,
      settings: { ...user.settings, analyseOnSave },
    };

    if (analyseOnSave) {
      if (selProject?.data.data?.output?.lcombs.length === 0) {
        await props.analyse(selProject);
      } else {
      }
    }

    await dispatch(UserSlice.actions.setUser(updatedUser)); // update Redux store

    await updateSettingsForUser(updatedUser);
  };

  const handleDisclaimerChange = async (showDisclaimer: boolean) => {
    console.log({ ...user.settings, showDisclaimer });
    const updatedUser = {
      ...user,
      settings: { ...user.settings, showDisclaimer },
    };

    await dispatch(UserSlice.actions.setUser(updatedUser)); // update Redux store

    await updateSettingsForUser(updatedUser);
  };

  const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  return (
    <SXModalBase
      header={t("general.settings")}
      show={props.isSettingsModalOpen}
      size="lg"
      close={() => {
        dispatch(closeModal("settingsModal"));
      }}
      body={
        <Container>
          {/* <Row style={{ marginBottom: "1rem" }}>
            <Col xs={3}>
              <strong>{t("application_settings_.label")}</strong>
            </Col>
            <hr />
          </Row>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={3}>{t("analyse_on_save_.label")}</Col>
            <Col xs={3}>
              <Form.Check
                type="switch"
                id="analyse-on-save-switch"
                label={t("")}
                checked={user.settings.analyseOnSave}
                onChange={(e) => {
                  handleAnalyseOnSaveChange(e.target.checked);
                  // localStorage.setItem("disclaimerAccepted", e.target.checked ? "true" : "false");
                }}
              />
            </Col>
          </Row> */}
          <Row style={{ marginBottom: "1rem" }}>
            <Col xs={3}>
              <strong>{t("about_.label")}</strong>
            </Col>
            <hr />
          </Row>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={3}>{t("show_disclaimer_.label")}</Col>
            <Col xs={3}>
              <Form.Check
                type="switch"
                id="disclaimer-switch"
                label={t("")}
                checked={user.settings.showDisclaimer}
                onChange={(e) => {
                  handleDisclaimerChange(e.target.checked);
                  // localStorage.setItem("disclaimerAccepted", e.target.checked ? "true" : "false");
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: "1rem" }}>
            <Col xs={3}>
              <strong>{t("general.language")}</strong>
            </Col>
            <hr />
          </Row>
          <Row style={{ marginBottom: "1rem" }}>
            <Col xs={3}>{t("general.language")}</Col>
            <Col xs={3}>
              <SXDropdown
                name="language"
                list={languages as any}
                val={(languages.find((el) => el.code === i18n.language) as any) || null}
                localisation={i18n}
                lang={i18n.language}
                style={{ paddingRight: 50 }}
                onUpdate={async (value) => {
                  if (value === null) {
                    return;
                  }
                  handleLanguageSelect(String((value as any).code));
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: "1rem" }}>
            <Col xs={3}>
              <strong>{t("settings_header_viewport_.label")}</strong>
            </Col>
            <hr />
          </Row>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={3}>{t("auto_zoom_viewport_enabled_.label")}</Col>
            <Col xs={3}>
              <Form.Check
                type="switch"
                id="viewport-switch"
                label={""}
                checked={user.settings.autoZoomViewportEnabled}
                onChange={(e) => {
                  const updatedUser = {
                    ...user,
                    settings: { ...user.settings, autoZoomViewportEnabled: e.target.checked },
                  };

                  dispatch(UserSlice.actions.setUser(updatedUser)); // update Redux store

                  updateSettingsForUser(updatedUser);
                }}
              />
            </Col>
          </Row>
        </Container>
      }
      footer={
        <>
          <Button
            className="modal-btn"
            onClick={() => {
              resetDefault();
            }}
          >
            {t("button_reset_.label")}
          </Button>
          <Button
            id="Okbtn"
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("settingsModal"));
            }}
          >
            {t("general.ok")}
          </Button>
        </>
      }
    />
  );
};
